<div class="multi-select" (clickOutside)="clickOutsideMultiSelect()">
    <div
        class="multi-select-input"
        [ngClass]="{
            'multi-select-input-opened': optionsVisible,
            'multi-select-disabled': disabled,
            'multi-select-input-invalid': !isFormValid,
        }"
        (click)="optionsVisible = true && !disabled">
        <div class="placeholder" *ngIf="(selectedIdsSet.size === 0 || optionsById.size === 0) && placeHolder">
            {{ placeHolder }}
        </div>

        <div *ngIf="optionsById.size > 0 && selectedIdsSet.size === 1" class="multi-select-input-selected">
            <img
                *ngIf="optionsById.get(selectedIdsSet.values().next().value)?.iconPath"
                [src]="optionsById.get(selectedIdsSet.values().next().value)?.iconPath"
                class="option-img" />
            <div appLongTextTooltip>
                {{ optionsById.get(selectedIdsSet.values().next().value)?.displayName }}
            </div>
        </div>
        <div *ngIf="optionsById.size > 0 && selectedIdsSet.size > 1" class="multi-select-input-selected">{{ selectedIdsSet.size }} selected</div>
        <img
            *ngIf="optionsById.size > 0 && selectedIdsSet.size > 0"
            src="assets/images/common/cancel-grey.svg"
            class="cancel-img"
            (click)="clearSelections(); $event.stopPropagation()" />
        <div class="divider"></div>
        <img src="assets/images/arrows/empty-arrow-down.svg" class="drop-down" alt="expand" />
    </div>
    <div class="multi-select-options" *ngIf="optionsVisible">
        <div class="multi-select-options-search">
            <app-autocomplete-search
                placeholder="Search..."
                *ngIf="withSearch"
                (autocompleteOnChange)="onSearch($event)"
                [values]="searchValues"
                [inMultiSelect]="true">
            </app-autocomplete-search>
        </div>
        <div class="separator"></div>
        <div class="multi-select-options-list">
            <div
                *ngIf="withSelectAll && filteredOptions$.value.length > 0"
                class="multi-select-option"
                [ngClass]="{ 'multi-select-option-selected': allChecked }"
                (click)="onSelectAll()">
                <mat-checkbox color="primary" [checked]="allChecked" (click)="$event.stopPropagation()" (change)="onSelectAll()"> </mat-checkbox>
                <div class="multi-select-option-text" appLongTextTooltip>All</div>
            </div>

            <div class="multi-select-options-container">
                <div *ngFor="let optionGroup of filteredOptions$ | async; let i = index">
                    <div *ngIf="!optionGroup.displayName">
                        <div
                            *ngFor="let option of optionGroup.options"
                            class="multi-select-option"
                            [ngClass]="{
                                'multi-select-option-selected': selectedIdsSet.has(option.id) && !option.disabled,
                                'multi-select-option-disabled': option.disabled,
                            }"
                            (click)="onSelect(option.id)">
                            <mat-checkbox
                                color="primary"
                                [checked]="selectedIdsSet.has(option.id)"
                                (click)="$event.stopPropagation()"
                                (change)="onSelect(option.id)">
                            </mat-checkbox>
                            <img *ngIf="option.iconPath" [src]="option.iconPath" class="option-img" alt="icon" />
                            <div class="multi-select-option-text" appLongTextTooltip>
                                {{ option.displayName | beautifyDisplayString }}
                            </div>
                        </div>
                    </div>
                    <div *ngIf="optionGroup.displayName">
                        <app-accordion
                            [inMultiSelect]="true"
                            [boldTitle]="false"
                            [selectionIndication]="isGroupSelected(optionGroup)"
                            [expanded]="selectedIdsSet.size === 0 || !isGroupSelected(optionGroup)"
                            [accordionTitle]="optionGroup.displayName | beautifyDisplayString"
                            [selectedCount]="optionGroup.selectedCount">
                            <div
                                *ngFor="let option of optionGroup.options"
                                class="multi-select-option"
                                [ngClass]="{
                                    'multi-select-option-selected': selectedIdsSet.has(option.id) && !option.disabled,
                                    'multi-select-option-disabled': option.disabled,
                                }"
                                (click)="onSelect(option.id)">
                                <mat-checkbox
                                    color="primary"
                                    [checked]="selectedIdsSet.has(option.id)"
                                    (click)="$event.stopPropagation()"
                                    (change)="onSelect(option.id)">
                                </mat-checkbox>
                                <img *ngIf="option.iconPath" [src]="option.iconPath" class="option-img" />
                                <div class="multi-select-option-text" appLongTextTooltip>
                                    {{ option.withoutBeautifyDisplayName ? option.displayName : (option.displayName | beautifyDisplayString) }}
                                </div>
                            </div>
                        </app-accordion>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
